/**
 * Maps UI index keys to dictionary API vegetation index enum values (norm curves).
 */

import {VegetationIndexType} from '@app/pages/electronic-field-map/pages/fields/passport/forms/crop-chart-index/managers/norm-data-manager';

/** Index value string (e.g. from INDEX_LAYER_OPTIONS) → API enum for crop norm lookup. */
export const INDEX_TO_VEGETATION_TYPE: Record<string, VegetationIndexType> = {
  Arvi: VegetationIndexType.ARVI,
  Evi: VegetationIndexType.EVI,
  Gndvi: VegetationIndexType.GNDVI,
  Mndwi: VegetationIndexType.MNDWI,
  Ndmi: VegetationIndexType.NDMI,
  Ndvi: VegetationIndexType.NDVI,
  Ndwi: VegetationIndexType.NDWI,
  Orvi: VegetationIndexType.ORVI,
  Osavi: VegetationIndexType.OSAVI,
};
